import KeyboardAction from '../context/KeyboardAction';

export const withKeyboard = (Component: any) => () =>
  (
    <KeyboardAction>
      <Component />
    </KeyboardAction>
  );
